import { render } from "./EditProductModal.vue?vue&type=template&id=0824f413"
import script from "./EditProductModal.vue?vue&type=script&lang=js"
export * from "./EditProductModal.vue?vue&type=script&lang=js"

import "./EditProductModal.vue?vue&type=style&index=0&id=0824f413&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__